import { render, staticRenderFns } from "./ControlCheckbox.vue?vue&type=template&id=0c633c24"
import script from "./ControlCheckbox.vue?vue&type=script&lang=js"
export * from "./ControlCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ControlCheckbox.vue?vue&type=style&index=0&id=0c633c24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports